import { message } from "antd";
import DesignApi from "../../api/DesignApi";

export function usePublishDesign() {
  function publish(designId: string) {
    DesignApi.publish(designId).catch(() => {
      message.error("Couldn't publish changes. Please try again.");
    });
    message.success("Changes published");
  }

  return { publish };
}
